import { __ } from '@wordpress/i18n';
import {useState} from '@wordpress/element';
import {PanelBody,RangeControl} from '@wordpress/components';
import {Responsive, VayuBlocksDimensions, VayuBlocksBorder, VayuBlocksColorControl, VayuBlocksCursorPanel,
        VayuBlocksFlexPanel, VayuBlocksPositionPanel,VayuBlocksWidthController, VayuBlocksAdvAniMation,
    VayuBlocksMouseFollower, VayuBlocksDisplayCondition} from '@vayu-blocks';
import { SlideButton } from '@vayu-blocks/global';

export const VayuBlocksAdvancePanel = (props) => {
    
    const { attributes, setAttributes, clientId, exclude, video = false, openPanels, onTogglePanel} = props;

    const [hover, sethover] = useState('normal');

    const handelHover = (value) => {
        sethover(value);
        if (typeof clickBorderHover === 'function') {
            clickBorderHover(value);
        }
    }

    const isExcluded = (key) => Array.isArray(exclude) && exclude.includes(key);

    // 👇 fallback internal openPanels state if not passed via props
    const [internalPanels, setInternalPanels] = useState({});

    // use fallback if props not provided
    const isControlled = typeof openPanels === 'object' && typeof onTogglePanel === 'function';

    const safeOpenPanels = isControlled ? openPanels : internalPanels;

    const handleToggle = (key) => {
        if (isControlled) {
            onTogglePanel(key);
        } else {
            setInternalPanels((prev) => ({
                ...prev,
                [key]: !prev[key],
            }));
        }
    };

    return (
            <>
                {/* Dimensions (Padding and Margin) */}
                {!isExcluded('dimensions') && (
                    <VayuBlocksDimensions
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        dimensions={{
                            padding: { key: 'advPadding', value: attributes.advPadding },
                            margin: { key: 'advMargin', value: attributes.advMargin },
                        }}
                    />
                )}
    
                {(!isExcluded('width') || !isExcluded('position')) && (
                    <PanelBody 
                        title={__('Layout', 'vayu-blocks')} 
                        opened={safeOpenPanels['advance-layout'] ?? false}
                        onToggle={() => handleToggle('advance-layout')}
                    >
                        {!isExcluded('width') && (
                            <VayuBlocksWidthController 
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                width={{ key: 'advWidth', value: attributes.advWidth }}
                                clientId={clientId}
                            /> 
                        )}
                        {!isExcluded('position') && (
                            <VayuBlocksPositionPanel
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                position={{ key: 'advPosition', value: attributes.advPosition }}
                            />
                        )}
                    </PanelBody>
                )}

                {/* Flex Panel */}
                {!isExcluded('flex') && (
                    <PanelBody 
                        title={__('Flex Child', 'vayu-blocks')} 
                        opened={safeOpenPanels['advance-flex'] ?? false}
			            onToggle={() => handleToggle('advance-flex')}
                    >
                        <VayuBlocksFlexPanel
                            onChange={(key, value) => setAttributes({ [key]: value })}
                            flex={{ key: 'advFlexItem', value: attributes.advFlexItem }}
                        />
                    </PanelBody>
                )}
    
                {/* Background */}
                {!isExcluded('background') && (
                    <PanelBody 
                        title={__('Background', 'vayu-blocks')} 
                        opened={safeOpenPanels['advance-background'] ?? false}
			            onToggle={() => handleToggle('advance-background')}
                    >

                        <SlideButton  
                            button={{ normal: "Normal", hover: "Hover" }}
                            onChange={(value)=>handelHover(value)}
                            defaultValue={hover}
                        />  
        
                        {hover === 'normal' && (
                            <VayuBlocksColorControl
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                background={{ value: attributes.advBackground, backgroundKey: 'advBackground' }}
                                video= {video}
                            />
                        )}
                        {hover === 'hover' && (
                            <VayuBlocksColorControl
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                background={{ value: attributes.advBackgroundHover, backgroundKey: 'advBackgroundHover' }}
                            />
                        )}
                    </PanelBody>
                )}
    
                {/* Border and Box Shadow */}
                {!isExcluded('border') && (
                    <PanelBody 
                        title={__('Border & Box Shadow', 'vayu-blocks')} 
                        opened={safeOpenPanels['advance-border'] ?? false}
			            onToggle={() => handleToggle('advance-border')} 
                        className="th-button-panel"
                    >
                        <SlideButton  
                            button={{ normal: "Normal", hover: "Hover" }}
                            onChange={(value)=>handelHover(value)}
                            defaultValue={hover}
                        />  
        
                        {hover === 'normal' && (
                            <VayuBlocksBorder
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                border={{ key: 'advBorder', value: attributes.advBorder }}
                                borderRadius={{ key: 'advBorderRadius', value: attributes.advBorderRadius }}
                                dropShadow={{ key: 'advDropShadow', value: attributes.advDropShadow }}
                            />
                        )}
                        {hover === 'hover' && (
                            <VayuBlocksBorder
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                border={{ key: 'advBorderHover', value: attributes.advBorderHover }}
                                borderRadius={{ key: 'advBorderRadiusHover', value: attributes.advBorderRadiusHover }}
                                dropShadow={{ key: 'advDropShadowHover', value: attributes.advDropShadowHover }}
                            />
                        )}
                    </PanelBody>
                )}

                {/* Animation */}
                {!isExcluded('animation') && (
                <PanelBody 
                    title={__('Hover Effect', 'vayu-blocks')} 
                    opened={safeOpenPanels['advance-hover'] ?? false}
			        onToggle={() => handleToggle('advance-hover')} 
                    className="th-button-panel"
                >
                    <div className="vb-adv-hover">
                    <VayuBlocksAdvAniMation
                        animationData={{dataKey:"advAnimation", value: attributes.advAnimation}}
                        onChange={(key, value) => {setAttributes({ [key]: value });}}
                    />
                    </div>

                    {/* Transition */}
                    {!isExcluded('transition') && (
                        <RangeControl
                            label={__('Transition Duration', 'vayu-blocks')}
                            value={attributes.advTransition}
                            onChange={(value) => setAttributes({ advTransition:value })}
                            step={0.1}
                            min={0}
                            max={3}
                            allowReset={true}
                        />
                    )}
                </PanelBody>
                )}

                {(!isExcluded('Cursor')|| !isExcluded('cursorFollower')) && (
                    <PanelBody 
                        title={__('Cursor', 'vayu-blocks')} 
                        opened={safeOpenPanels['advance-cursor'] ?? false}
			            onToggle={() => handleToggle('advance-cursor')} 
                        className="th-button-panel"
                    >

                        <VayuBlocksCursorPanel
                            cursorValue={attributes.advCursor}
                            onChange={(key, value) => setAttributes({ [key]: value })}
                            datakey="advCursor"
                        />

                        {!isExcluded('cursorFollower') && (
                            <>
                            <br/>
                            <VayuBlocksMouseFollower
                                followerValue={attributes.advFollower}
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                datakey="advFollower"
                            />
                            </>
                        )}
                        
                    </PanelBody>
                )}

                {/* Display Condition */}
                {!isExcluded('displayConditions') && (
                    <PanelBody 
                        title={__('Display Conditions', 'vayu-blocks')} 
                        className="th-container-panel" 
                        opened={safeOpenPanels['advance-display'] ?? false}
                        onToggle={() => handleToggle('advance-display')}
                    >
                        <VayuBlocksDisplayCondition
                            onChange={(key, value) => setAttributes({ [key]: value })}
                            discond={{ key: 'advDisplayCond', value: attributes.advDisplayCond }}
                        />

                        <p className="vb-index-hide-para">Above setting will only take effect once you are on the live page, and not while you're editing.</p>
                    </PanelBody>
                )}

                {/* Responsive */}
                {!isExcluded('responsive') && (
                    <PanelBody 
                        title={__('Responsive', 'vayu-blocks')} 
                        className="th-container-panel" 
                        opened={safeOpenPanels['advance-responsive'] ?? false}
			            onToggle={() => handleToggle('advance-responsive')}
                    >
                        <Responsive
                            onChange={(key, value) => setAttributes({ [key]: value })}
                            value={{ key: 'advResponsive', value: attributes.advResponsive }}
                        />
                    </PanelBody>
                )}

            </>
    );
}